








import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  CoinflowPurchaseProps,
  getHandlers,
  getWalletPubkey,
} from '../lib/common';
import CoinflowIFrame from '../CoinflowIFrame.vue';

@Component({
  components: {
    CoinflowIFrame,
  },
})
export default class MobileWalletButton extends Vue {
  @Prop({ type: Object, required: true }) args!: CoinflowPurchaseProps & {
    color: 'white' | 'black';
  };

  @Prop({ type: String, required: true }) route!: string;

  get iframeProps() {
    const walletPubkey = getWalletPubkey(this.args);
    return {
      ...this.args,
      walletPubkey,
      transaction: undefined,
      routePrefix: 'form',
      route: `/${this.route}/${this.args.merchantId}`,
    };
  }

  get messageHandlers() {
    return {
      ...getHandlers(this.args),
      handleHeightChange: this.args.handleHeightChange,
    };
  }

  handleMessage(event: { data: string }) {
    console.log('handleMessage', event);
    try {
      const res = JSON.parse(event.data);
      if (!('method' in res) || res.method !== 'getToken') {
        return;
      }
    } catch (e) {
      return;
    }

    this.args.onSuccess?.(event.data);
  }
}
